"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSactionState = exports.defaultSactionSortOptions = void 0;
var SactionState_1 = require("@/pages/search/states/SactionState");
exports.defaultSactionSortOptions = [
    {
        id: 0,
        key: SactionState_1.SactionSortField.QUALITY,
        name: 'Best Match',
        order: SactionState_1.SactionSortOrder.DESC,
    },
    {
        id: 1,
        key: SactionState_1.SactionSortField.PRICE,
        name: 'Least Price',
        order: SactionState_1.SactionSortOrder.ASC,
    },
    {
        id: 2,
        key: SactionState_1.SactionSortField.PRICE,
        name: 'Highest Price',
        order: SactionState_1.SactionSortOrder.DESC,
    },
    {
        id: 3,
        key: SactionState_1.SactionSortField.NET_SIZE,
        name: 'Greatest Saleable Size',
        order: SactionState_1.SactionSortOrder.DESC,
    },
    {
        id: 4,
        key: SactionState_1.SactionSortField.NET_SIZE,
        name: 'Lowest Saleable Size',
        order: SactionState_1.SactionSortOrder.ASC,
    },
    {
        id: 5,
        key: SactionState_1.SactionSortField.GROSS_SIZE,
        name: 'Greatest Gross Size',
        order: SactionState_1.SactionSortOrder.DESC,
    },
    {
        id: 6,
        key: SactionState_1.SactionSortField.GROSS_SIZE,
        name: 'Lowest Gross Size',
        order: SactionState_1.SactionSortOrder.ASC,
    },
    {
        id: 7,
        key: SactionState_1.SactionSortField.DISTRICT,
        name: 'District Name (A-Z)',
        order: SactionState_1.SactionSortOrder.ASC,
    },
    {
        id: 8,
        key: SactionState_1.SactionSortField.DISTRICT,
        name: 'District Name (Z-A)',
        order: SactionState_1.SactionSortOrder.DESC,
    },
    {
        id: 9,
        key: SactionState_1.SactionSortField.BUILDING,
        name: 'Building Name (A-Z)',
        order: SactionState_1.SactionSortOrder.ASC,
    },
    {
        id: 10,
        key: SactionState_1.SactionSortField.BUILDING,
        name: 'Building Name (Z-A)',
        order: SactionState_1.SactionSortOrder.DESC,
    },
    {
        id: 11,
        key: SactionState_1.SactionSortField.UDPATE,
        name: 'Last Updated',
        order: SactionState_1.SactionSortOrder.DESC,
    },
    {
        id: 12,
        key: SactionState_1.SactionSortField.PRICEPERSQFT,
        name: 'Highest Price per sq.ft.',
        order: SactionState_1.SactionSortOrder.DESC,
    },
    {
        id: 13,
        key: SactionState_1.SactionSortField.PRICEPERSQFT,
        name: 'Lowest Price per sq.ft.',
        order: SactionState_1.SactionSortOrder.ASC,
    },
];
exports.defaultSactionState = {
    nameList: 'List',
    nameMap: 'Map',
    nameGrid: 'Grid',
    nameSortBy: 'Sort By',
    nameClear: 'Clear',
    nameConfirm: 'Confirm',
    nameBack: 'Back',
    selected: 0,
    view: SactionState_1.SactionView.GRID,
    sortOptions: exports.defaultSactionSortOptions,
};
